import { ScrollSync } from "../ScrollSync/ScrollSync";
var DataGrid = /** @class */ (function () {
    function DataGrid(dotNetRef, id) {
        this._dotNetRef = dotNetRef;
        this._id = id;
        this.init();
    }
    DataGrid.prototype.init = function () {
        var headerRowGroups = document.querySelector("#".concat(this._id, ">.header>.rowgroups"));
        var headerMainRowGroup = document.querySelector("#".concat(this._id, ">.header>.rowgroups>.rowgroup.main"));
        var contentFreezedRowGroup = document.querySelector("#".concat(this._id, ">.content>.rowgroups>.rowgroup.freezed"));
        var contentMainRowGroup = document.querySelector("#".concat(this._id, ">.content>.rowgroups>.rowgroup.main"));
        headerRowGroups.style.marginInlineEnd = "".concat(this.getScrollbarWidth(), "px");
        if (contentFreezedRowGroup)
            contentFreezedRowGroup.style.paddingBottom = "".concat(this.getScrollbarWidth(), "px");
        new ScrollSync(contentMainRowGroup, [contentFreezedRowGroup], { syncHorizontal: false, syncVertical: true });
        new ScrollSync(contentMainRowGroup, [headerMainRowGroup], { syncHorizontal: true, syncVertical: false });
    };
    DataGrid.prototype.getScrollbarWidth = function () {
        // Create the measurement node
        var scrollDiv = document.createElement("div");
        scrollDiv.style.width = '100px';
        scrollDiv.style.height = '100px';
        scrollDiv.style.overflow = 'scroll';
        scrollDiv.style.position = 'absolute';
        scrollDiv.style.top = '-9999px';
        document.body.appendChild(scrollDiv);
        // Get the scrollbar width
        var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        // Delete the DIV 
        document.body.removeChild(scrollDiv);
        return scrollbarWidth;
    };
    DataGrid.create = function (dotNetRef, id) {
        return new DataGrid(dotNetRef, id);
    };
    return DataGrid;
}());
export { DataGrid };
